/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Serializer for the incoming PlannerBookingView POST request data.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface PlannerBookingViewRequest { 
    patientId: string;
    ignoreWarnings?: boolean;
    appointmentResourceId: number;
    startDate: string;
    appointmentTypeId: number;
}
export const PlannerBookingViewRequest_patientId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PlannerBookingViewRequest_ignoreWarnings_Validators: ValidatorFn[] =
    [ ];

export const PlannerBookingViewRequest_appointmentResourceId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PlannerBookingViewRequest_startDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PlannerBookingViewRequest_appointmentTypeId_Validators: ValidatorFn[] =
    [  Validators.required, ];


